const setAvailabilityStyles = (isChatAvailable) => {
  const styleElement = document.createElement('style');
  styleElement.textContent = `
.show-when-chat-available {
  display: ${isChatAvailable ? 'block' : 'none'};
}
.hide-when-chat-available {
  display: ${isChatAvailable ? 'none' : 'block'};
}
.show-when-chat-unavailable {
  display: ${isChatAvailable ? 'none' : 'block'};
}
.hide-when-chat-unavailable {
  display: ${isChatAvailable ? 'block' : 'none'};
}
`.replace(/((\r|\n|\r\n)\s*|\s+)/g, ' ');
  document.body.appendChild(styleElement);
};
export default setAvailabilityStyles;
